import { sensorLabelKey } from "./sensors";
/**
 * Maps API `alarmType` (domain enum int) to `common:alarmTypes.*` translation keys. The limit alarms of a new-hardware sensor
 * (8 / 9) name the sensor (`sensorType`), so a new sensor needs no new alarm type or translation here.
 */
export function alarmTypeLabel(alarmType, t, sensorType) {
    switch (alarmType) {
        case 1:
            return t("common:alarmTypes.lowTemperature");
        case 2:
            return t("common:alarmTypes.highTemperature");
        case 3:
            return t("common:alarmTypes.fatReplacement");
        case 4:
            return t("common:alarmTypes.openDoor");
        case 5:
            return t("common:alarmTypes.noNodeCommunication");
        case 6:
            return t("common:alarmTypes.noApCommunication");
        case 7:
            return t("common:alarmTypes.temperatureReadingDelay");
        case 8:
        case 9: {
            const key = sensorLabelKey(sensorType);
            return t(alarmType === 8
                ? "common:alarmTypes.lowSensorLimit"
                : "common:alarmTypes.highSensorLimit", { sensor: key ? t(key) : t("common:alarmTypes.unknown") });
        }
        default:
            return t("common:alarmTypes.unknown");
    }
}
/** Alarm types raised when a reading falls below its low limit (the temperature, or any new-hardware sensor). */
export const isLowAlarmType = (alarmType) => alarmType === 1 || alarmType === 8;
/** Alarm types raised when a reading rises above its high limit. */
export const isHighAlarmType = (alarmType) => alarmType === 2 || alarmType === 9;
